"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketReplicationInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=GetBucketReplicationInput.js.map